import React from 'react';
import { HStack } from '@chakra-ui/react';
import { Button } from 'components/Button';
import { Menu, MenuProps, MenuItemProps } from 'components/Menu';
import { Icon } from 'components/Icon';

export interface ConversationCardOverlayProps {
  isOpenInOverlay?: boolean;
  openInOverlay: () => void;
}

export interface ConversationCardPinProps {
  isPinned?: boolean;
  togglePin: (isPinned: boolean) => void;
}

export interface ConversationCardButtonsProps {
  overlayProps?: ConversationCardOverlayProps;
  pinProps?: ConversationCardPinProps;
  headerMenuProps?: MenuProps;
}

interface ConversationCardButtonsComponentProps extends ConversationCardButtonsProps {
  isHovering: boolean;
  setIsHovering: (isHovering: boolean) => void;
}

export const ConversationCardButtons = ({
  overlayProps,
  pinProps,
  headerMenuProps,
  isHovering,
  setIsHovering,
}: ConversationCardButtonsComponentProps): JSX.Element => {
  const { isOpenInOverlay, openInOverlay } = overlayProps || {};
  const { isPinned, togglePin } = pinProps || {};
  const { listProps } = headerMenuProps || {};
  const pinIconName = isPinned ? 'pinCancel' : 'pin';

  return (
    <HStack className="ConversationCard__Menu" spacing={1}>
      {overlayProps && (
        <Button
          data-testid="conversation-card-overlay-icon-button"
          variant="secondarySubtle"
          borderRadius="sm"
          isActive={isOpenInOverlay}
          onClick={(): void => {
            if (openInOverlay) {
              openInOverlay();
            }

            if (isHovering) {
              setIsHovering(false);
            }
          }}
          iconName="popup"
          size="sm"
        />
      )}
      {pinProps && (
        <Button
          data-testid="conversation-card-pin-toggle-icon-button"
          variant={isPinned ? 'secondarySubtleDestructive' : 'secondarySubtle'}
          borderRadius="sm"
          onClick={(): void => {
            if (togglePin) {
              togglePin(!isPinned);
            }

            if (isHovering) {
              setIsHovering(false);
            }
          }}
          iconName={pinIconName}
          size="sm"
        />
      )}
      {headerMenuProps && (
        <Menu
          buttonProps={
            headerMenuProps.buttonProps || {
              variant: 'secondarySubtle',
              size: 'sm',
              borderRadius: 'sm',
              leftIconName: 'dotsVertical',
              showRightIcon: false,
            }
          }
          closeOnSelect={false}
          isLazy
          {...headerMenuProps}
          listProps={{
            ...listProps,
            menuItems: [
              ...(pinProps
                ? [
                    {
                      'data-testid': 'conversation-card-pin-toggle-dropdown-button',
                      label: `${isPinned ? 'Unpin' : 'Pin'} Conversation`,
                      value: 'PinConversation',
                      variant: isPinned ? 'danger' : 'default',
                      leftElement: <Icon size="md" variant={isPinned ? 'danger' : 'default'} name={pinIconName} />,
                      onSelect: (): void => {
                        if (togglePin) {
                          togglePin(!isPinned);
                        }
                      },
                    } as MenuItemProps,
                  ]
                : []),
              ...(listProps?.menuItems || []),
            ],
          }}
        />
      )}
    </HStack>
  );
};
